import type {Mapper} from '@automapper/core';
import {TransactionDownloadServerStrategy, type TransactionViewModelKeys} from '@igp/shared/features/transaction';
import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IDownloadStrategy} from '@igp/shared/redux/download';

import {ServiceTypes} from '@ioc-container';

import {transactionServiceTypes} from './constants';

export class TransactionContainerFacade extends ContainerFacade {
    bindAll() {
        this._container
            .bind<IDownloadStrategy<TransactionViewModelKeys>>(transactionServiceTypes.downloadServerStrategy)
            .toDynamicValue(
                context =>
                    new TransactionDownloadServerStrategy(
                        context.get<Mapper>(ServiceTypes.AutoMapper),
                        context.get(ServiceTypes.TransactionService)
                    )
            );
    }
}
